var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGrowingPeopleLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 638.13 232.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#302e3d;}.cls-2{fill:url(#linear-gradient);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 104.85,
    y1: 216.42,
    x2: 104.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#346ab1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#2f7ba8",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#22a891",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1eb68a",
    stopOpacity: 0.95
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "growing-people-logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Laag_2",
    "data-name": "Laag 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Laag_1-2",
    "data-name": "Laag 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M277.48,61.88V55.47h22V94.63c-2.25.46-6.21,1.07-11.88,1.8a112.73,112.73,0,0,1-14.1,1.11q-17.49,0-24.24-10.25t-6.76-31.12a96.4,96.4,0,0,1,1.4-17.71,38.6,38.6,0,0,1,4.89-13q6.65-11.19,24.59-11.19a115.38,115.38,0,0,1,22.26,2.22l3.84.81-.35,6.18A141.64,141.64,0,0,0,274,20.75q-14.1,0-19.05,8.45t-5,26.86q0,18.41,5,26.68T273.87,91a104.66,104.66,0,0,0,18.52-1.86V61.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M316.17,96.37V38.11H323V46.5a64,64,0,0,1,10.55-5.83A49.65,49.65,0,0,1,345.06,37v7a65.9,65.9,0,0,0-10.48,3.2,81.87,81.87,0,0,0-8.51,3.79l-3,1.75V96.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M351.71,67.13q0-16.44,5.53-23.31T376.12,37q13.33,0,18.88,6.87t5.53,23.31q0,16.43-5.07,23.42t-19.28,7q-14.22,0-19.35-7T351.71,67.13Zm7.22-.18q0,13.81,3.21,19.11t14,5.3q10.77,0,14-5.36t3.26-19q0-13.7-3.67-18.76t-13.57-5.07q-9.92,0-13.58,5T358.93,67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M409.85,38.11H417l12.82,52.2h1.63l15.15-51h7.34l15.15,51h1.75l12.82-52.2h7.1L476.16,96.37H464l-13.75-48-13.87,48h-12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M503.31,23.55V14.81h6.87v8.74Zm0,72.82V38.11h6.87V96.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M534.54,96.37h-6.88V38.11h6.88v4.31q9.78-5.47,19-5.47,11.65,0,15.56,6.17T573,65.73V96.37h-7V66.08q0-13.41-2.56-18.12t-11-4.72a32.73,32.73,0,0,0-8.56,1.22A36,36,0,0,0,537,47l-2.44,1.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M637,105.23q0,9.9-6.35,14.33T610.86,124q-13.4,0-18.53-3.84t-5.12-14.1a13.43,13.43,0,0,1,2.09-7.87,33.27,33.27,0,0,1,7.34-6.82q-2.91-1.86-2.91-7.92,0-1.86,2.8-7.34l.93-1.75q-9.56-4-9.55-17.59Q587.91,36.94,609,37a42.72,42.72,0,0,1,10.48,1.16l1.75.35,16.9-.35v6.18l-11.65-.24q4.18,4.2,4.19,13.81t-5.3,14q-5.31,4.37-16.72,4.37a33.62,33.62,0,0,1-5.95-.47q-2.33,5.72-2.33,7.22,0,3.86,2.28,4.72t13.57.94q11.31.06,16,3.37T637,105.23Zm-42.76.35q0,7,3.49,9.67t13.52,2.68q10,0,14.33-2.85t4.32-9.56q0-6.7-3.15-8.68t-12-2l-13.17-.47a22.86,22.86,0,0,0-5.83,5.31A10.39,10.39,0,0,0,594.2,105.58ZM595,56.7q0,7.52,3.27,10.6t11,3.09q7.74,0,11-3t3.26-10.66q0-7.64-3.26-10.78t-11-3.15q-7.75,0-11,3.21T595,56.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M274,182.73H257.67v24.82H244.74V127.73H274q27.15,0,27.15,26.8,0,13.75-6.81,21T274,182.73Zm-16.31-11.19h16.2q14,0,14-17,0-8.16-3.38-11.89t-10.6-3.73h-16.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M353.57,197.06l3.26-.35.24,9.44a120.5,120.5,0,0,1-23.54,2.68q-12.94,0-18.59-7.11T309.29,179q0-31,25.29-31,24.46,0,24.47,26.69l-.82,9.09H322.11q.11,7.23,3.14,10.6t11.31,3.38Q344.83,197.76,353.57,197.06Zm-7-23.07q0-8.62-2.74-12.06t-9.26-3.44q-6.54,0-9.5,3.61T322,174Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M374.49,155.58q6-7.58,20-7.58t20,7.58q6,7.57,6,22.72t-5.83,22.84q-5.83,7.7-20.16,7.69t-20.16-7.69q-5.82-7.69-5.82-22.84T374.49,155.58ZM384,193.45q2.68,4.67,10.49,4.66T405,193.45q2.67-4.66,2.68-15.27t-2.86-15q-2.85-4.43-10.31-4.43t-10.31,4.43q-2.87,4.44-2.86,15T384,193.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M433,232.6V149.29h12.59v3.61q8-4.89,15-4.9,11.54,0,16.89,7.05t5.37,23.66q0,16.6-6.12,23.36t-20,6.76a68.38,68.38,0,0,1-11.07-1.05V232.6Zm25.4-73.29a26.65,26.65,0,0,0-10.95,2.44l-1.75.82V197a52.57,52.57,0,0,0,10.26.93q7.92,0,10.95-4.55t3-15.5Q470,159.3,458.44,159.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M496.31,207.55v-82.5H509v82.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M566.58,197.06l3.26-.35.23,9.44a120.32,120.32,0,0,1-23.53,2.68q-12.94,0-18.59-7.11T522.3,179q0-31,25.29-31,24.46,0,24.47,26.69l-.82,9.09H535.12q.11,7.23,3.14,10.6t11.31,3.38Q557.84,197.76,566.58,197.06Zm-7-23.07q0-8.62-2.74-12.06t-9.26-3.44q-6.54,0-9.5,3.61T535,174Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M141,208.23a12.91,12.91,0,0,1-5.18,6.43,12.19,12.19,0,0,1-7.69,1.73c-4.82-.23-8.64-2.84-11-8.16l-39.56-98.9,6.28.94L48,208.23c-2.14,5.39-6,8-11,8.16a13,13,0,0,1-7.85-1.73,13.89,13.89,0,0,1-5.34-6.43L.94,145.47a14.15,14.15,0,0,1-.94-5,13,13,0,0,1,3.45-9.11q3.45-3.76,9.42-3.76a13.14,13.14,0,0,1,6.91,1.88,10.15,10.15,0,0,1,4.39,6.28L40.48,182.8l-6.59-.32L70.31,88.29q3.45-7.85,11.93-7.85a11.37,11.37,0,0,1,7.07,2,11.82,11.82,0,0,1,3.92,5.81l38.31,94.19-7.85.63,61.51-175C187,2.62,190.85,0,197.13,0a12.07,12.07,0,0,1,8.63,3.45c2.41,2.31,4.17,4.88,3.92,9.44a9,9,0,0,1-.46,2.65M99.71,47.16A17.07,17.07,0,1,1,82.64,30.1,17.06,17.06,0,0,1,99.71,47.16Z"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrowingPeopleLogo);
export default __webpack_public_path__ + "static/media/growing-people-logo.e3bb2f972ba9495f4758c4b73024e354.svg";
export { ForwardRef as ReactComponent };